/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RfidUploadEntity
 */
export interface RfidUploadEntity {
    /**
     *
     * @type {string}
     * @memberof RfidUploadEntity
     */
    rfid?: string;
    /**
     *
     * @type {string}
     * @memberof RfidUploadEntity
     */
    operation?: RfidUploadEntityOperationEnum;
    /**
     *
     * @type {string}
     * @memberof RfidUploadEntity
     */
    status?: RfidUploadEntityStatusEnum;
    /**
     *
     * @type {string}
     * @memberof RfidUploadEntity
     */
    rule?: RfidUploadEntityRuleEnum;
    /**
     * Organisation id
     * @type {string}
     * @memberof RfidUploadEntity
     */
    organisation?: string;
    /**
     *
     * @type {string}
     * @memberof RfidUploadEntity
     */
    label?: string;
    /**
     * User account email address, or UserAccountId prefixed with #
     * @type {string}
     * @memberof RfidUploadEntity
     */
    userAccount?: string;
    /**
     * Device owner email address, or DeviceOwnerId prefixed with #
     * @type {string}
     * @memberof RfidUploadEntity
     */
    deviceOwner?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof RfidUploadEntity
     */
    deviceGroupTags?: Array<string>;
}

/**
 * @export
 */
export const RfidUploadEntityOperationEnum = {
    Unknown: "Unknown",
    Insert: "Insert",
    Update: "Update",
} as const;
export type RfidUploadEntityOperationEnum =
    (typeof RfidUploadEntityOperationEnum)[keyof typeof RfidUploadEntityOperationEnum];

/**
 * @export
 */
export const RfidUploadEntityStatusEnum = {
    Active: "Active",
    Suspended: "Suspended",
    Archived: "Archived",
} as const;
export type RfidUploadEntityStatusEnum =
    (typeof RfidUploadEntityStatusEnum)[keyof typeof RfidUploadEntityStatusEnum];

/**
 * @export
 */
export const RfidUploadEntityRuleEnum = {
    Unknown: "Unknown",
    DeviceOwner: "DeviceOwner",
    DeviceGroups: "DeviceGroups",
    UserAccount: "UserAccount",
} as const;
export type RfidUploadEntityRuleEnum =
    (typeof RfidUploadEntityRuleEnum)[keyof typeof RfidUploadEntityRuleEnum];

/**
 * Check if a given object implements the RfidUploadEntity interface.
 */
export function instanceOfRfidUploadEntity(
    value: object,
): value is RfidUploadEntity {
    return true;
}

export function RfidUploadEntityFromJSON(json: any): RfidUploadEntity {
    return RfidUploadEntityFromJSONTyped(json, false);
}

export function RfidUploadEntityFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): RfidUploadEntity {
    if (json == null) {
        return json;
    }
    return {
        rfid: json["rfid"] == null ? undefined : json["rfid"],
        operation: json["operation"] == null ? undefined : json["operation"],
        status: json["status"] == null ? undefined : json["status"],
        rule: json["rule"] == null ? undefined : json["rule"],
        organisation:
            json["organisation"] == null ? undefined : json["organisation"],
        label: json["label"] == null ? undefined : json["label"],
        userAccount:
            json["userAccount"] == null ? undefined : json["userAccount"],
        deviceOwner:
            json["deviceOwner"] == null ? undefined : json["deviceOwner"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
    };
}

export function RfidUploadEntityToJSON(value?: RfidUploadEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        rfid: value["rfid"],
        operation: value["operation"],
        status: value["status"],
        rule: value["rule"],
        organisation: value["organisation"],
        label: value["label"],
        userAccount: value["userAccount"],
        deviceOwner: value["deviceOwner"],
        deviceGroupTags: value["deviceGroupTags"],
    };
}
